'use client';
import React, { forwardRef } from 'react';
import cx from 'clsx';
import '@mantine/hooks';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import classes from '../Loader.module.css.mjs';

const Bars = forwardRef(({ className, ...others }, ref) => /* @__PURE__ */ React.createElement(Box, { component: "span", className: cx(classes.barsLoader, className), ...others, ref }, /* @__PURE__ */ React.createElement("span", { className: classes.bar }), /* @__PURE__ */ React.createElement("span", { className: classes.bar }), /* @__PURE__ */ React.createElement("span", { className: classes.bar })));

export { Bars };
//# sourceMappingURL=Bars.mjs.map
